import createApiClient from '../../../utils/createApiClient';
import { logError } from '../../../utils/logging';
import getShopifyGraphQLUpperLocale from './getShopifyGraphQLUpperLocale';

/**
 * Fetch product collection by handle
 */
export const getProductCollectionByHandle = async (
  token: string,
  handle: string,
): Promise<Record<string, string> | null> => {
  const storefrontApiClient = createApiClient(token);

  if (!storefrontApiClient) {
    return null;
  }

  const locale = getShopifyGraphQLUpperLocale();
  const query = `
    query getCollection($handle: String!, $language: LanguageCode, $country: CountryCode) @inContext(country: $country, language: $language) {
      collection(handle: $handle) {
        title
        description
      }
  }`;

  try {
    const { data, errors } = await storefrontApiClient.request(query, {
      variables: {
        handle,
        language: locale,
        country: window.Shopify?.country,
      },
    });

    if (errors) {
      logError(
        `Storefront API failed when fetching metaobject by ID, using fallback: ${errors}`,
      );
      return null;
    }

    if (!data.collection) {
      logError(`Product collection with handle ${handle} not found`);
      return null;
    }

    return data.collection;
  } catch (error) {
    logError(
      `Error fetching product collection by handle ${handle}: ${error}`,
      error,
    );
    return null;
  }
};
